import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { callService } from '../../../utilities/api/service';
import { userDataFormSubmit, userDataChangeAction } from '../../../actions/UserData';
import PhoneInput from 'react-phone-input-2';
import Text from '../../Global/Text';
import { findTranslation } from '../../../utilities/common';

// Constants
import { stepComponents } from '../../../constants/Steps';

const wrapperTag = import.meta.env.VITE_WRAPPER_TAG;

let initialPhoneNumber;
// State variables for managing consent and user data

let validatedInputLength = false;
let configurationApplied = false;

/*
  You can place the errorPageConfig inside the sections, such as registrationNumberSection
*/
const ErrorPage = ({
  dispatch,
  errorPageConfig,
  packageData,
  userData,
  actions,
  compactLayout,
  customErrorCode
}) => {
  // Returns the specific component based on the variant and the parameters
  // The variant defines what component it should be, while the parameters determines the data we provide the component with
  const returnComponent = (variant, parameters) => {
    let title = '';
    let InputComponent = null;
    let params = parameters;
    switch (variant) {
      case 'accordion':
        InputComponent = stepComponents.accordion;
        break;
      case 'accordionAdvanced':
        InputComponent = stepComponents.accordionAdvanced;
        break;
      case 'coverageOverview':
        InputComponent = stepComponents.coverageOverview;
        break;
      case 'button':
        InputComponent = stepComponents.button;
        break;
      case 'navigationContainer':
        InputComponent = stepComponents.navigationContainer;
        break;
      case 'condition':
        InputComponent = stepComponents.condition;
        break;
      case 'columnLayout':
        InputComponent = stepComponents.columnLayout;
        break;
      case 'componentGroup':
        InputComponent = stepComponents.componentGroup;
        break;
      case 'hero':
        InputComponent = stepComponents.hero;
        break;
      case 'infoBox':
        InputComponent = stepComponents.infoBox;
        break;
      case 'productBox':
        InputComponent = stepComponents.productBox;
        break;
      case 'productSelector':
        InputComponent = stepComponents.productSelector;
        break;
      case 'slider':
        InputComponent = stepComponents.slider;
        break;
      case 'carousel':
        InputComponent = stepComponents.carousel;
        break;
      case 'link':
        InputComponent = stepComponents.link;
        break;
      case 'coverage':
        InputComponent = stepComponents.coverage;
        break;
      case 'productSummary':
        InputComponent = stepComponents.productSummary;
        break;
      case 'productConfirmation':
        InputComponent = stepComponents.productConfirmation;
        break;
      case 'productCard':
        InputComponent = stepComponents.productCard;
        break;
      case 'recommendation':
        InputComponent = stepComponents.recommendation;
        break;
      case 'recommendationContact':
        InputComponent = stepComponents.recommendationContact;
        break;
      case 'graphicLoader':
        InputComponent = stepComponents.graphicLoader;
        break;
      case 'textLoader':
        InputComponent = stepComponents.textLoader;
        break;
      case 'idleAction':
        InputComponent = stepComponents.idleAction;
        break;
      case 'label':
        InputComponent = stepComponents.label;
        break;
      case 'icon':
        InputComponent = stepComponents.icon;
        break;
      case 'consent':
        InputComponent = stepComponents.consent;
        break;
      case 'checkbox':
        InputComponent = stepComponents.checkbox;
        break;
      case 'checkboxButtons':
        InputComponent = stepComponents.checkboxButtons;
        break;
      case 'radio':
        InputComponent = stepComponents.radio;
        break;
      case 'radioButtons':
        InputComponent = stepComponents.radioButtons;
        break;
      case 'select':
        InputComponent = stepComponents.select;
        break;
      case 'toggleSwitch':
        InputComponent = stepComponents.toggleSwitch;
        break;
      case 'autoSuggest':
        InputComponent = stepComponents.autoSuggest;
        break;
      case 'text':
        InputComponent = stepComponents.text;
        break;
      case 'email':
        InputComponent = stepComponents.email;
        break;
      case 'number':
        InputComponent = stepComponents.number;
        break;
      case 'password':
        InputComponent = stepComponents.password;
        break;
      case 'tel':
        InputComponent = stepComponents.tel;
        break;
      case 'space':
        InputComponent = stepComponents.space;
        break;
      case 'divider':
        InputComponent = stepComponents.divider;
        break;
      case 'cprText':
        InputComponent = stepComponents.cprText;
        break;
      case 'address':
        InputComponent = stepComponents.address;
        break;
      case 'cvrText':
        InputComponent = stepComponents.cvrText;
        break;
      case 'textarea':
        InputComponent = stepComponents.textarea;
        break;
      case 'datePicker':
        InputComponent = stepComponents.datePicker;
        break;
      case 'phoneInput':
        InputComponent = stepComponents.phoneInput;
        break;
      case 'textBlock':
        InputComponent = stepComponents.textBlock;
        break;
      case 'textHeader':
        InputComponent = stepComponents.textHeader;
        break;
      case 'title':
        InputComponent = stepComponents.title;
        break;
      case 'textSimple':
        InputComponent = stepComponents.textSimple;
        break;
      case 'ajax':
        InputComponent = stepComponents.ajax;
        break;
      case 'notification':
        InputComponent = stepComponents.notification;
        break;
      case 'backButton':
        InputComponent = stepComponents.backButton;
        break;
      case 'actionText':
        InputComponent = stepComponents.actionText;
        break;
      case 'trustPilotWidget':
        InputComponent = stepComponents.trustPilotWidget;
        break;
      case 'optionalCoverages':
        InputComponent = stepComponents.optionalCoverages;
        break;
      case 'carDetails':
        InputComponent = stepComponents.carDetails;
        break;
  
      default:
        console.warning('Unknown variant ' + variant); // eslint-disable-line
    }
    
    return <InputComponent {...params} />
  }

  const defaultConfig = packageData.initialValues.errorPageConfig;
  const configuration = {};

  // The configuration level is the layer at which it is taken from.
  // The defaultConfig is overwritten by the partnerConfig, which in turn is overwritten by the defaultErrorCodeConfig, which in turn in overwritten by the partnerErrorCodeConfig.
  // defaultConfig -> errorPageConfig -> defaultConfig.errorCodeConfigurations -> errorPageConfig.errorCodeConfigurations
  const applyErrorConfig = (configurationLevel) => {
    configuration.contentDisplayCustomContent = configurationLevel.content?.displayCustomContent ?? configuration.contentDisplayCustomContent,
    configuration.contentGeneralContentDisplayCustomContent = configurationLevel.content?.generalContent?.displayCustomContent ?? configuration.contentGeneralContentDisplayCustomContent,
    configuration.contentWithPhoneNumberDisplayCustomContent = configurationLevel.content?.withPhoneNumber?.displayCustomContent ?? configuration.contentWithPhoneNumberDisplayCustomContent,
    configuration.contentWithPhoneNumberCustom = configurationLevel.content?.withPhoneNumber?.custom ?? configuration.contentWithPhoneNumberCustom,
    configuration.contentWithoutPhoneNumberDisplayCustomContent = configurationLevel.content?.withoutPhoneNumber?.displayCustomContent ?? configuration.contentWithoutPhoneNumberDisplayCustomContent,
    configuration.contentWithoutPhoneNumberCustom = configurationLevel.content?.withoutPhoneNumber?.custom ?? configuration.contentWithoutPhoneNumberCustom,
    configuration.contentLeadGivenDisplayCustomContent = configurationLevel.content?.leadGiven?.displayCustomContent ?? configuration.contentLeadGivenDisplayCustomContent,
    configuration.contentLeadGivenCustom = configurationLevel.content?.leadGiven?.custom ?? configuration.contentLeadGivenCustom,
    configuration.contentLeadGivenCustomContentColumnReverse = configurationLevel.content?.leadGiven?.customContentColumnReverse ?? configuration.contentLeadGivenCustomContentColumnReverse,
    configuration.errorPageImageSrc = configurationLevel.image?.src ?? configuration.errorPageImageSrc;
    configuration.errorPageImageSrcSet = configurationLevel.image?.srcSet ?? configuration.errorPageImageSrcSet;
    configuration.errorPageImageAlt = configurationLevel.image?.alt ?? configuration.errorPageImageAlt;
    configuration.errorPageConsentToLeadGivenHeader = configurationLevel.content?.leadGiven?.standard?.header ?? configuration.errorPageConsentToLeadGivenHeader;
    configuration.errorPageHeader = configurationLevel.content?.generalContent?.standard?.header ?? configuration.errorPageHeader;
    configuration.errorPageConsentToLeadGivenParagraph = configurationLevel.content?.leadGiven?.standard?.paragraph ?? configuration.errorPageConsentToLeadGivenParagraph;
    configuration.errorPageButtonOneText = configurationLevel.content?.withPhoneNumber?.standard?.buttonOneText ?? configuration.errorPageButtonOneText;
    configuration.errorPageButtonTwoText = configurationLevel.content?.withPhoneNumber?.standard?.buttonTwoText ?? configuration.errorPageButtonTwoText;
    configuration.errorPageButtonOneVariant = configurationLevel.content?.withPhoneNumber?.standard?.buttonOneVariant ?? configuration.errorPageButtonOneVariant;
    configuration.errorPageButtonTwoVariant = configurationLevel.content?.withPhoneNumber?.standard?.buttonTwoVariant ?? configuration.errorPageButtonTwoVariant;
    configuration.errorPageInputLabel = configurationLevel.content?.withoutPhoneNumber?.standard?.inputLabel ?? configuration.errorPageInputLabel;
    configuration.errorPageInputLabelPlaceholder = configurationLevel.content?.withoutPhoneNumber?.standard?.inputPlaceholder ?? configuration.errorPageInputLabelPlaceholder;
    configuration.errorPageInputErrorMessage = configurationLevel.content?.withoutPhoneNumber?.standard?.inputErrorMessage ?? configuration.errorPageInputErrorMessage;
    configuration.errorPageInputSubmitText = configurationLevel.content?.withoutPhoneNumber?.standard?.inputSubmitText ?? configuration.errorPageInputSubmitText;
    configuration.errorPageInputSubmitVariant = configurationLevel.content?.withoutPhoneNumber?.standard?.inputSubmitVariant ?? configuration.errorPageInputSubmitVariant;
    configuration.errorPageSubHeaderWithPhoneNumber = configurationLevel.content?.withPhoneNumber?.standard?.subHeader ?? configuration.errorPageSubHeaderWithPhoneNumber;
    configuration.errorPageSubHeaderWithoutPhoneNumber = configurationLevel.content?.withoutPhoneNumber?.standard?.subHeader ?? configuration.errorPageSubHeaderWithoutPhoneNumber;
    configuration.leadData = configurationLevel.leadConfig ?? configuration.leadData;
    configuration.leadGivenStandardHide = configurationLevel.content?.leadGiven?.standard?.hidden ?? configuration.leadGivenStandardHide;
    configuration.withPhoneNumberStandardHide = configurationLevel.content?.withPhoneNumber?.standard?.hidden ?? configuration.withPhoneNumberStandardHide;
    configuration.withoutPhoneNumberStandardHide = configurationLevel.content?.withoutPhoneNumber?.standard?.hidden ?? configuration.withoutPhoneNumberStandardHide;
    configuration.withPhoneNumberButtonsHidden = configurationLevel.content?.withPhoneNumber?.standard?.buttonsHidden ?? configuration.withPhoneNumberButtonsHidden;
    configuration.withoutPhoneNumberButtonsHidden = configurationLevel.content?.withoutPhoneNumber?.standard?.buttonsHidden ?? configuration.withoutPhoneNumberButtonsHidden;
  }

  // Checks for and applies the different levels of the configuration (global/default -> Page specific -> global/default errorCode -> page specific  errorCode).
  if(Object.keys(configurationApplied).length === 0){
    // Apply default configuration
    if(defaultConfig){
      applyErrorConfig(defaultConfig);
    }
    // Apply page-specific configuration
    if(errorPageConfig){
      applyErrorConfig(errorPageConfig);
    }
    // If an errorCode or customErrorCode is present, apply the errorCode specific configs
    if(userData.errorCode || customErrorCode){
      // Apply default errorCode configs
      if(defaultConfig?.errorCodeConfigurations){
        for (let key in defaultConfig?.errorCodeConfigurations) {
          if(key === userData.errorCode || key === customErrorCode){
            applyErrorConfig(defaultConfig.errorCodeConfigurations[key]);
          }
        }
      }
      // Apply page-specific errorCode configs
      for (let key in errorPageConfig?.errorCodeConfigurations) {
        if(key === userData.errorCode || key === customErrorCode){
          applyErrorConfig(errorPageConfig.errorCodeConfigurations[key]);
        }
      }
    }
    configurationApplied = true;
  }
  const leadService = findTranslation(configuration.leadData.service, packageData.translations);
  const leadParams = findTranslation(configuration.leadData.params, packageData.translations);
  const leadForProduct = findTranslation(configuration.leadData.forProduct, packageData.translations);
  const leadFormValues = findTranslation(configuration.leadData.formValues, packageData.translations);

  // Check if the initialPhoneNumber is undefined
  if (initialPhoneNumber === undefined) {
    // If userData.telephoneNumber exists, set initialPhoneNumber to true; otherwise, set it to false
    if (userData.telephoneNumber) {
      initialPhoneNumber = true;
    } else {
      initialPhoneNumber = false;
    }
  }

  const getCountryCode = () => {
    const initialPhonenumber = document.querySelector(wrapperTag).querySelector(".form-control") ? document.querySelector(wrapperTag).querySelector(".form-control").value : document.querySelector(wrapperTag).shadowRoot.querySelector(".form-control").value;
    const sanitizedCountryCode = initialPhonenumber.split(" ")[0].replace("+", "");
    return sanitizedCountryCode;
  }

  // Function to get the phone number from the DOM
  const getPhoneNumber = () => {
    const initialPhonenumber = document.querySelector(wrapperTag).querySelector(".form-control") ? document.querySelector(wrapperTag).querySelector(".form-control").value : document.querySelector(wrapperTag).shadowRoot.querySelector(".form-control").value;
    let sanitizedPhoneNUmber = initialPhonenumber.substr(initialPhonenumber.split(" ")[0].length + 1);
    sanitizedPhoneNUmber = sanitizedPhoneNUmber.replaceAll(" ", "");
    return sanitizedPhoneNUmber;
  };

  // Custom function to handle phone number submission
  const customPhoneNumberSubmit = () => {
    if (userData.telephoneNumber) {
      callService(leadService, leadParams, leadForProduct, leadFormValues, dispatch, actions);
      dispatch(userDataChangeAction({
        fields: [{
          field: "consentToLeadGiven",
          value: true,
        }]
      }));
      if(userData.produktnavn){
        userData.consentToLeadGivenProductList && userData.consentToLeadGivenProductList.length > 0 ?
        dispatch(userDataChangeAction({
          fields: [{
            field: "consentToLeadGivenProductList",
            value: [...userData.consentToLeadGivenProductList, userData.produktnavn],
          }]
        }))
        : 
        dispatch(userDataChangeAction({
          fields: [{
            field: "consentToLeadGivenProductList",
            value: [userData.produktnavn],
          }]
        }))
      }
    }
  };

  // This function handles key presses, particularly for phone number input.
  const handleKeyPress = (event) => {
    // Get the initial phone number value from the DOM.
    const initialPhoneNumber = document.querySelector(wrapperTag).querySelector(".form-control") ? document.querySelector(wrapperTag).querySelector(".form-control").value : document.querySelector(wrapperTag).shadowRoot.querySelector(".form-control").value;

    // Remove spaces from the phone number.
    let sanitizedPhoneNumber = initialPhoneNumber.substr(initialPhoneNumber.split(" ")[0].length + 1);
    sanitizedPhoneNumber = sanitizedPhoneNumber.replaceAll(" ", "");

    // Check if the pressed key is a digit (0-9).
    if (event.key >= "0" && event.key <= "9") {
      // Validate input length after adding a digit.
      validatedInputLength = sanitizedPhoneNumber.length + 1 > 7;
    } else if (event.key === "Backspace" || event.key === "Delete") {
      // Validate input length after removing a digit.
      validatedInputLength = sanitizedPhoneNumber.length - 1 > 7;
    }

    // Dispatch form submission with updated user data.
    dispatch(userDataFormSubmit({...userData, telephoneNumber: getPhoneNumber(), "countryCode": getCountryCode()}));
  };

  // This function is called when an input field gains focus (on focus).
  const inputOnFocus = () => {
    // Get the input DOM element from the appropriate route.
    const inputDOMRoute = document.querySelector(wrapperTag).querySelector(".form-control") ? document.querySelector(wrapperTag).querySelector(".form-control") : document.querySelector(wrapperTag).shadowRoot.querySelector(".form-control");

    // Check if the input element exists and if its onkeypress event is null.
    if (inputDOMRoute && inputDOMRoute.onkeypress === null) {
      // If both conditions are met, add an event listener for keydown (keypress).
      return inputDOMRoute.addEventListener("keydown", handleKeyPress);
    }
  };

  // Function to apply phone number data to state (dispatch an action)
  const applyPhoneNumberToState = () => {
    // Dispatch an action (e.g., userDataFormSubmit) with newUserData
    dispatch(userDataFormSubmit({...userData, telephoneNumber: getPhoneNumber()}));
  };

  const phoneInputProps = {
    id: 'telephoneNumber',
    type: 'phoneInput',
    className:'form__field',
    onFocus:()=>{inputOnFocus()},
    country: "dk",
    disableCountryCode: false,
    countryCodeEditable: false,
    placeholder: configuration.errorPageInputLabelPlaceholder,
    defaultErrorMessage: configuration.errorPageInputErrorMessage
  };

  return (
    <div className={compactLayout | configuration.compact | errorPageConfig?.compact ? "errorPageWrapperCompact" : "errorPageWrapper"}>
      {configuration.errorPageImageSrc ?
        <section className='errorPageImageWrapper'>
          <img
            src={configuration.errorPageImageSrc.includes("${") ? findTranslation(configuration.errorPageImageSrc, packageData.translations) : configuration.errorPageImageSrc}
            srcSet={configuration.errorPageImageSrcSet.includes("${") ? findTranslation(configuration.errorPageImageSrcSet, packageData.translations) : configuration.errorPageImageSrcSet}
            alt={configuration.errorPageImageAlt.includes("${") ? findTranslation(configuration.errorPageImageAlt, packageData.translations) : configuration.errorPageImageAlt}
            loading='lazy'
          />
        </section> 
      : <></> }
      <section className='errorPagePrimaryContent'>
          {
            userData.consentToLeadGiven === true && userData.consentToLeadGivenProductList?.includes(userData.produktnavn) ?
              <div className="leadGiven" style={configuration.contentLeadGivenCustomContentColumnReverse === true ? { display: "flex", flexDirection : "column-reverse" } : {}}>
                {!configuration.leadGivenStandardHide && <div className="leadGivenStandard">
                  <Text className='errorPageHeader' value={configuration.errorPageConsentToLeadGivenHeader} component="h3"/>
                  <Text className='errorPageSubHeader' value={configuration.errorPageConsentToLeadGivenParagraph} component="p"/>
                </div>}
                {configuration.contentDisplayCustomContent !== false | configuration.contentLeadGivenDisplayCustomContent === true ? <div className="leadGivenCustom">
                  <div className="leadGivenCustom">
                    {configuration.contentLeadGivenCustom.map((data) => (
                      returnComponent(data.type, data)
                    ))}
                  </div>
                </div> : <></>}
              </div>
            :
            <>
              <Text className='errorPageHeader' value={configuration.errorPageHeader} component="h3"/>
              {initialPhoneNumber ? !configuration.withPhoneNumberStandardHide && <Text className='errorPageSubHeader' value={configuration.errorPageSubHeaderWithPhoneNumber} component="p"/> : !configuration.withoutPhoneNumberStandardHide && <Text className='errorPageSubHeader' value={configuration.errorPageSubHeaderWithoutPhoneNumber} component="p"/>}
              <div className='errorPagePrimaryContentButtons'>
                {
                  initialPhoneNumber && !configuration.withPhoneNumberStandardHide ?
                    <div className="withPhoneNumber">
                      {!configuration.withPhoneNumberButtonsHidden && <div className="withPhoneNumberStandard">
                        <anchor-button className="errorPageButtonOne" text={findTranslation(configuration.errorPageButtonOneText, packageData.translations)} variant={findTranslation(configuration.errorPageButtonOneVariant, packageData.translations)} onClick={() => {customPhoneNumberSubmit()}} />
                        <anchor-button className="errorPageButtonTwo" text={findTranslation(configuration.errorPageButtonTwoText, packageData.translations)} variant={findTranslation(configuration.errorPageButtonTwoVariant, packageData.translations)} onClick={() => {location.reload()}} />
                      </div>}
                      {configuration.contentDisplayCustomContent !== false | configuration.contentWithPhoneNumberDisplayCustomContent === true ? <div className="leadGivenCustom">
                        <div className="withPhoneNumberCustom">
                          {configuration.contentWithPhoneNumberCustom.map((data) => (
                            returnComponent(data.type, data)
                          ))}
                        </div>
                      </div> : <></>}
                    </div>
                  :
                    !configuration.withoutPhoneNumberStandardHide && <div className="withoutPhoneNumber">
                      {!configuration.withoutPhoneNumberButtonsHidden && <div className="withoutPhoneNumberStandard">
                        <PhoneInput {...phoneInputProps} specialLabel={findTranslation(configuration.errorPageInputLabel, packageData.translations)}/>
                        <anchor-button className="errorPageInputFieldSubmitButton" disabled={!validatedInputLength} text={findTranslation(configuration.errorPageInputSubmitText, packageData.translations)} variant={findTranslation(configuration.errorPageInputSubmitVariant, packageData.translations)} onClick={() => {applyPhoneNumberToState(); customPhoneNumberSubmit()}}/>
                      </div>}
                      {configuration.contentDisplayCustomContent !== false | configuration.contentWithoutPhoneNumberDisplayCustomContent === true ? <div className="leadGivenCustom">
                        <div className="withoutPhoneNumberCustom">
                          {configuration.contentWithoutPhoneNumberCustom.map((data) => (
                            returnComponent(data.type, data)
                          ))}
                        </div>
                      </div> : <></>}
                    </div>
                }
              </div>
            </>
          }
          {!userData.consentToLeadGiven && !userData.consentToLeadGivenProductList?.includes(userData.produktnavn) && <Text className='errorDisplay' value={configuration.errorDisplay} component="p"/>}
      </section>
    </div>
  )
};

export default compose(
  connect(state => {
    const {
      userData,
    } = state;
    return {
      userData,
    };
  })
)(ErrorPage);

ErrorPage.propTypes = {
  actions: PropTypes.object,
  userData: PropTypes.object,
  packageData: PropTypes.object,
  dispatch: PropTypes.func,
  errorPageConfig: PropTypes.object,
  compactLayout: PropTypes.bool | undefined,
  customErrorCode: PropTypes.string | undefined
};